var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.env)?_c('div',{staticClass:"env font-xxxs bg-primary text-white p-1"},[_vm._v("\n  Env: "+_vm._s(_vm.env)+". iOS: "+_vm._s(_vm.isIosWebView ? 'Y' : 'N')+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }